import React from 'react';
import { CardBody as CardBodyStrap } from 'reactstrap';
const CardBody = props => {
    return (
        <CardBodyStrap>{props.children}</CardBodyStrap>
    )
};
export default CardBody